import { tokenContract } from '@daymade/api-contracts';
import { ClientInferResponseBody } from '@ts-rest/core';
import ArcadePopupWithDimmedBackground from 'components/token-town/ArcadePopupWithDimmedBackground';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useEffect, useState } from 'react';
import { PurchaseCheckout } from './checkout';
import { PurchaseConfirmation } from './confirmation';
import { QuantitySelect } from './quantity-select';

const purchaseFlow = {
  selectTokenQuantity: 'SelectTokenQuantity',
  tokenPurchaseCheckout: 'TokenPurchaseCheckout',
  tokenPurchaseConfirmation: 'TokenPurchaseConfirmation',
};

export type TPurchaseTokensResponse = ClientInferResponseBody<
  typeof tokenContract.auth.purchaseTokens,
  200
>;

interface IPurchaseTokens {
  onClose: () => void;
  tokenBalance: number;
  currentPage?: { name: string };
}

const PurchaseTokens = ({
  onClose,
  tokenBalance,
  currentPage,
}: IPurchaseTokens) => {
  const { updateTokenBalance } = useUserStore();
  const [tokenOrder, setTokenOrder] = useState<TPurchaseTokensResponse | null>(
    null
  );
  const [flowStage, setFlowStage] = useState(purchaseFlow.selectTokenQuantity);

  useEffect(() => {
    async function handleUpdateTokenBalance() {
      return updateTokenBalance();
    }
    handleUpdateTokenBalance();
  }, []);

  return (
    <ArcadePopupWithDimmedBackground
      additionalClassName="tokenPurchaseFlow"
      onClose={async () => {
        if (flowStage === purchaseFlow.tokenPurchaseConfirmation) {
          await updateTokenBalance();
        }
        onClose();
      }}
    >
      {flowStage === purchaseFlow.selectTokenQuantity && (
        <QuantitySelect
          tokenBalance={tokenBalance}
          handleTokenOrderCreated={(order) => {
            setTokenOrder(order);
            setFlowStage(purchaseFlow.tokenPurchaseCheckout);
          }}
        />
      )}

      {flowStage === purchaseFlow.tokenPurchaseCheckout && (
        <PurchaseCheckout
          tokenOrder={tokenOrder}
          handlePaymentCompleted={() => {
            setFlowStage(purchaseFlow.tokenPurchaseConfirmation);
          }}
        />
      )}

      {flowStage === purchaseFlow.tokenPurchaseConfirmation &&
        tokenOrder?.order.id && (
          <PurchaseConfirmation
            tokensPurchased={tokenOrder.tokenOrder.tokenAmount}
            onClose={async () => {
              await updateTokenBalance();
              onClose();
            }}
            currentPageName={currentPage?.name}
          />
        )}

      <style jsx>
        {`
          :global(.arcadePopup.tokenPurchaseFlow .childrenContainer) {
            margin-bottom: 1em;
            max-width: 375px;
          }

          :global(.arcadePopupWithDimmedBackground .roundedButton) {
            width: 100%;
          }

          :global(.tokenPurchaseFlow h3) {
            margin-bottom: 1.5em;
            font-family: 'Press Start 2P', 'Montserrat', sans-serif !important;
            text-transform: uppercase !important;
          }
        `}
      </style>
    </ArcadePopupWithDimmedBackground>
  );
};

export default PurchaseTokens;
